import style from "./style.scss";

const Ligature = ({ children }) => (
  <span class={style.ligature}>{children}</span>
);

export default Ligature;
